import { render, staticRenderFns } from "./clientTagHoverDown.vue?vue&type=template&id=89627678&scoped=true&"
import script from "./clientTagHoverDown.vue?vue&type=script&lang=js&"
export * from "./clientTagHoverDown.vue?vue&type=script&lang=js&"
import style0 from "./clientTagHoverDown.vue?vue&type=style&index=0&id=89627678&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89627678",
  null
  
)

component.options.__file = "clientTagHoverDown.vue"
export default component.exports